// src/pages/Admin/Casting/components/CastingHeader.jsx
import React, { useMemo, useState } from "react";
import { FaSyncAlt, FaTv, FaInfoCircle, FaBullhorn } from "react-icons/fa";

export default function CastingHeader({
  event,
  eventId,
  panel,
  setPanel,
  castState,
  onRefresh,
  onToggleScreen, // ✅ remplace onOpenDisplay
  onSetMode,
  isScreen = false, // ✅ optionnel (pour changer le libellé)
}) {
  const [imgOk, setImgOk] = useState(true);

  const modeLabel = useMemo(() => {
    const m = castState?.mode || "MATS";
    if (m === "MATS") return "TAPIS";
    return m; // "MESSAGE"
  }, [castState?.mode]);

  return (
    <div className="rounded-3xl bg-white/80 dark:bg-slate-900/70 backdrop-blur ring-1 ring-black/5 dark:ring-white/10 shadow-xl p-4 sm:p-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-4">
          {/* ✅ Photo event */}
          <div className="h-14 w-14 rounded-2xl overflow-hidden ring-1 ring-black/10 dark:ring-white/10 bg-slate-200 dark:bg-slate-800 shrink-0">
            {imgOk && event?.photo_url ? (
              <img
                src={event.photo_url}
                alt={event?.titre || "Evénement"}
                className="h-full w-full object-cover"
                onError={() => setImgOk(false)}
              />
            ) : (
              <div className="h-full w-full flex items-center justify-center text-xs text-slate-500 dark:text-slate-300">
                —
              </div>
            )}
          </div>

          <div>
            <h1 className="text-xl sm:text-2xl font-extrabold tracking-tight text-slate-900 dark:text-white">
              Casting / Affichage Compétition
            </h1>
            <p className="text-sm text-slate-600 dark:text-slate-300">
              {event?.titre ? (
                <>
                  <span className="font-semibold">{event.titre}</span>{" "}
                  <span className="opacity-80">• ID {eventId}</span>
                </>
              ) : (
                <>ID {eventId}</>
              )}
            </p>
          </div>
        </div>

        <div className="flex flex-wrap gap-2">
          <button
            onClick={onRefresh}
            className="inline-flex items-center gap-2 h-10 px-4 rounded-2xl bg-slate-100 hover:bg-slate-200 text-slate-800 dark:bg-slate-800 dark:hover:bg-slate-700 dark:text-white"
          >
            <FaSyncAlt /> Rafraîchir
          </button>

          {/* ✅ Ecran => bascule en mode “preview écran” (remplace toute la page) */}
          <button
            onClick={onToggleScreen}
            className="inline-flex items-center gap-2 h-10 px-4 rounded-2xl bg-blue-600 hover:bg-blue-700 text-white"
            title="Afficher l'écran (plein écran) dans cette page"
          >
            <FaTv /> {isScreen ? "Retour" : "Écran"}
          </button>
        </div>
      </div>

      {/* Mode + panneau */}
      <div className="mt-4 flex flex-wrap items-center gap-2">
        <span className="text-xs uppercase tracking-wider text-slate-500 dark:text-slate-300">
          Panneau
        </span>

        <button
          onClick={() => {
            setPanel("mats");
            onSetMode?.("MATS");
          }}
          className={[
            "h-9 px-4 rounded-2xl text-sm font-semibold ring-1 transition",
            panel === "mats"
              ? "bg-sky-600 text-white ring-sky-600"
              : "bg-white/70 dark:bg-slate-900/50 text-slate-800 dark:text-white ring-slate-200 dark:ring-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800",
          ].join(" ")}
        >
          <FaInfoCircle className="inline -mt-0.5 mr-2" />
          Répartition tapis
        </button>

        <button
          onClick={() => {
            setPanel("messages");
            onSetMode?.("MESSAGE");
          }}
          className={[
            "h-9 px-4 rounded-2xl text-sm font-semibold ring-1 transition",
            panel === "messages"
              ? "bg-sky-600 text-white ring-sky-600"
              : "bg-white/70 dark:bg-slate-900/50 text-slate-800 dark:text-white ring-slate-200 dark:ring-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800",
          ].join(" ")}
        >
          <FaBullhorn className="inline -mt-0.5 mr-2" />
          Messages
        </button>

        {/* ✅ Mode (et MATS => TAPIS) */}
        <span className="ml-auto text-xs text-slate-500 dark:text-slate-300">
          Mode : <b>{modeLabel}</b>
        </span>
      </div>
    </div>
  );
}
